export const CHILDCARE_APPOINTMENT_STEP = 15; // minutes
export const WELLNESS_APPOINTMENT_STEP = 30; // minutes
export const CLEANING_APPOINTMENT_STEP = 15; // minutes
export const EARLY_SURCHARGE_END_TIME = '08:00';
export const LATE_SURCHARGE_START_TIME = '20:00';
